export default {
  jp: {
    Common: {
      reset: 'クリア',
      close: '閉じる',
      back: '戻る'
    },
    Auth: {
      signUp: 'サインアップ',
      activation: 'アクティベーション',
      signIn: 'サインイン',
      signOut: 'サインアウト',
      passwordReset: 'パスワードリセット',
      passwordInitialize: 'パスワード初期化',
      passwordUpdate: 'パスワード更新',
      userId: 'ユーザID',
      email: 'メールアドレス',
      password: 'パスワード',
      reenterPassword: 'もう一度パスワードを入力してください。',
      verificationCode: '検証コード(Verification code)',
      sendVerificationCode: '検証コード送信',
      forgotPassword: 'パスワードを忘れた場合',
      sendPasswordResetMail: 'リセットメール送信',
      newpassword: '新しいパスワード',
      reenterNewPassword: 'もう新しい一度パスワードを入力してください。',
      updatePassword: 'パスワード更新',
      currentPassword: '現在のパスワード'
    }
  }
}
